import { wrapWithProvider } from "./redux/wrapper"
import "./styles/global.css"

export const wrapRootElement = wrapWithProvider

// Trigger an immediate page refresh when an update is found.
export function onServiceWorkerUpdateReady(): void {
  window.location.reload()
}
